var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Critical_duotone_line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5207 10.1858C18.6222 10.0843 18.7884 10.0888 18.8809 10.1985C20.1908 11.752 20.9399 13.7084 20.9966 15.7497C21.0004 15.8877 20.8881 15.9997 20.75 15.9997H16.245C16.1069 15.9997 15.9958 15.8877 15.9872 15.7499C15.9416 15.022 15.6978 14.3234 15.2864 13.7283C15.2148 13.6246 15.2229 13.4836 15.312 13.3945L18.5207 10.1858ZM17.8009 9.11854C17.9106 9.21105 17.9151 9.37726 17.8136 9.47875L14.6048 12.6875C14.5158 12.7766 14.3748 12.7847 14.2712 12.7131C13.805 12.391 13.2753 12.1716 12.7179 12.0698C12.594 12.0471 12.5 11.9417 12.5 11.8157V7.27788C12.5 7.13435 12.6207 7.01997 12.7637 7.03214C14.6178 7.18996 16.3782 7.91914 17.8009 9.11854ZM11.5 7.27788C11.5 7.13435 11.3794 7.01997 11.2364 7.03214C9.38228 7.18996 7.62183 7.91914 6.19917 9.11855C6.08943 9.21107 6.08499 9.37727 6.18648 9.47876L9.39524 12.6875C9.48431 12.7766 9.62528 12.7847 9.72892 12.7131C10.1951 12.391 10.7247 12.1716 11.2822 12.0698C11.4061 12.0471 11.5 11.9417 11.5 11.8157V7.27788ZM8.71367 13.7283C8.7853 13.6246 8.77716 13.4836 8.68808 13.3946L5.47935 10.1858C5.37787 10.0844 5.21167 10.0888 5.11915 10.1985C3.80929 11.7521 3.06018 13.7084 3.00351 15.7497C2.99968 15.8877 3.11197 15.9997 3.25004 15.9997L7.7551 15.9997C7.89317 15.9997 8.00429 15.8877 8.01292 15.7499C8.05849 15.022 8.30232 14.3234 8.71367 13.7283Z",
    fill: "#EFBA00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 11.8157C12.5 11.9417 12.5939 12.0471 12.7179 12.0698C13.2753 12.1716 13.8049 12.391 14.2711 12.7131C14.3748 12.7847 14.5157 12.7766 14.6048 12.6875L17.8135 9.47875C17.915 9.37726 17.9106 9.21105 17.8009 9.11854C16.3782 7.91914 14.6178 7.18996 12.7637 7.03214C12.6207 7.01997 12.5 7.13435 12.5 7.27788V11.8157Z",
    fill: "#EFBA00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalRequest);
export default __webpack_public_path__ + "static/media/TotalRequest.599e8c4e4a340dbe6495be8c9ef8174f.svg";
export { ForwardRef as ReactComponent };